export default function stripSlashes(str?: string | number | null) {
    if (typeof str !== "string") return "";

    return (str).replace(/-/g, "");
}
